import { doc, setDoc } from "firebase/firestore";

export async function updateProfileWithMigration({
    db,
    user,
    userProfile,
    newData,
    students,
    teachers,
    updateItem,
    setUserProfile,
    openAlert
}) {
    if (!user) {
        return;
    }

    if (user.isAnonymous) {
        try {
            const updatedProfile = { ...userProfile, ...newData };
            localStorage.setItem("guest_userProfile", JSON.stringify(updatedProfile));
            setUserProfile(updatedProfile);
        } catch (e) {
            console.error("Guest profile save failed", e);
            openAlert("게스트 저장 실패", "오류");
        }
        return;
    }

    try {
        const oldDeptName = userProfile?.deptName;
        const newDeptName = newData.deptName;
        const deptNameChanged = oldDeptName && newDeptName && oldDeptName !== newDeptName;

        if (deptNameChanged) {
            console.log(`🔄 Department name migration: "${oldDeptName}" → "${newDeptName}"`);

            const studentsToUpdate = students.filter((student) => student.grade === oldDeptName);
            for (const student of studentsToUpdate) {
                await updateItem("students", student.id, { ...student, grade: newDeptName });
            }
            console.log(`✅ Updated ${studentsToUpdate.length} students`);

            const teachersToUpdate = teachers.filter((teacher) => teacher.charge === oldDeptName);
            for (const teacher of teachersToUpdate) {
                await updateItem("teachers", teacher.id, { ...teacher, charge: newDeptName });
            }
            console.log(`✅ Updated ${teachersToUpdate.length} teachers`);

            if (newData.departmentColors && newData.departmentColors[oldDeptName]) {
                const colorValue = newData.departmentColors[oldDeptName];
                delete newData.departmentColors[oldDeptName];
                newData.departmentColors[newDeptName] = colorValue;
                console.log("✅ Migrated department color key");
            }

            if (newData.departmentThemeKeys && newData.departmentThemeKeys[oldDeptName]) {
                const themeKeyValue = newData.departmentThemeKeys[oldDeptName];
                delete newData.departmentThemeKeys[oldDeptName];
                newData.departmentThemeKeys[newDeptName] = themeKeyValue;
                console.log("✅ Migrated department theme key");
            }

            openAlert(`"${oldDeptName}" → "${newDeptName}" 마이그레이션 완료! 🎉\n(학생 ${studentsToUpdate.length}명, 교사 ${teachersToUpdate.length}명 업데이트됨)`, "부서명 변경 완료");
        }

        const docRef = doc(db, "users", user.uid);
        await setDoc(docRef, newData, { merge: true });
        setUserProfile((prev) => ({ ...prev, ...newData }));
    } catch (e) {
        console.error("프로필 업데이트 실패", e);
        openAlert("저장 중 오류가 발생했습니다.", "오류");
    }
}
